import { render, screen } from "@testing-library/react";
import DocumentSort from "./DocumentSort";

test("check rendering type listing details", () => {
  render(<DocumentSort />);
  expect(screen.getByText("Sort By")).toBeInTheDocument();
});
